import axios from '../../plugins/axios';
export const no_index_urls_module = {
    state: ()=>({
        pending: false,
        data: {
            current_page: 1,
            data: [],
            last_page: null,
            searchedKeyword:'',
        },
        message: null,
        success: null,
        error: null
    }),
    mutations: {
        fetch_no_index_urls_request(state){

            state.pending = true;
            
        },
        fetch_no_index_urls_success(state, payload){

            if(payload.loadData == 'new'){

                state.data.data = payload.urls.data;

            }
            if(payload.loadData == 'more'){

                let moreCustomers = payload.urls.data;

                moreCustomers.forEach(element => {

                    state.data.data.push(element);

                });

            }

            state.data.current_page = payload.urls.current_page;
            state.data.last_page = payload.urls.last_page;
            state.pending = false;
            state.success = true;
            state.error = null;
            state.message = payload.message;

        },
        fetch_no_index_urls_failure(state, payload){

            state.data.data = [];
            state.pending = false;
            state.success = false;
            state.error = payload.error;
            state.message = payload.message;

        },
        add_no_index_url_list(state,payload){

            state.data.data.unshift(payload);

        },
        update_no_index_url_list(state,payload){

            state.data.data[payload.index] = payload.updatedUrl;

        },
        update_no_index_url_status(state,payload){
            
            state.data.data[payload.index].isActive = payload.updatedCustomer.isActive;

        },
        delete_no_index_url_list(state,payload){

            state.data.data.splice(payload,1);

        },
        no_index_urls_bulk_action(state,payload){

            if(payload.action == 'delete'){

                state.data.data = state.data.data.filter((noIndexUrl)=>{

                    if(!payload.listIds.includes(noIndexUrl.id)){
                        
                        return noIndexUrl

                    }

                });

            }

        },
        update_searched_keyword(state,payload){ 

            state.data.searchedKeyword = payload.keyword;

        },
        remove_searched_keyword(state){

            state.data.searchedKeyword = '';

        },
        CLEAR_MODULE(state){

            state.pending = false;
            state.message = null;
            state.success = null;
            state.error = null;

            state.data.current_page = 1;
            state.data.data = [];
            state.data.last_page = null;
            state.data.searchedKeyword = '';

        }
    },
    actions:{
        async fetchStoreNoIndexUrlsRequest({commit},{size, page, loadData}){

            commit('fetch_no_index_urls_request');
            try{
                let res = null

                if(this.state.no_index_urls_module.data.searchedKeyword.length > 0){

                    res = await axios.get('/no-index-url/all',{
                        params:{
                            search: this.state.no_index_urls_module.data.searchedKeyword,
                            offset: size,
                            page: page
                        }
                    })

                }else{

                    res = await axios.get('/no-index-url/all',{
                        params:{
                            offset: size,
                            page: page
                        }
                    })

                }
                if(res.data.status_code == '1320'){

                    res.data.loadData = loadData;

                    commit('fetch_no_index_urls_success', res.data);

                }
            }catch(ex){

                commit('fetch_no_index_urls_failure', {error: ex, message: ex});
                
            }

        },
    },
    getters: {
        urls(state){

            return state.data.data;

        },
        keyword(state){

            return state.data.searchedKeyword;

        },
        currentPage(state){

            return state.data.current_page;

        },
        lastPage(state){

            return state.data.last_page;

        },
        isPending(state){

            return state.pending;

        },
        message(state){

            return state.message;
            
        },
        error:(state)=>state.error
    }
}